// Event listeners
export function setViewAppearCallback(callback: () => void): void {
  window.addEventListener('viewWillAppear', callback, false);
}
